export enum ActionStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum ActionCodeEnum {
  OU_VIEW = "OU_VIEW",
  OU_ADD = "OU_ADD",
  OU_EDIT = "OU_EDIT",
  OU_DEL = "OU_DEL",
  ROLES_VIEW = "ROLES_VIEW",
  ROLES_ADD = "ROLES_ADD",
  ROLES_EDIT = "ROLES_EDIT",
  ROLES_DEL = "ROLES_DEL",
  PROG_VIEW = "PROG_VIEW",
  PROG_ADD = "PROG_ADD",
  PROG_EDIT = "PROG_EDIT",
  PROG_DEL = "PROG_DEL",
  USER_VIEW = "USER_VIEW",
  USER_ADD = "USER_ADD",
  USER_EDIT = "USER_EDIT",
  USER_DEL = "USER_DEL",
  PART_LIST_VIEW = "PART_LIST_VIEW",
  PART_ADD = "PART_ADD",
  PART_EDIT = "PART_EDIT",
  PART_DEL = "PART_DEL",
  PART_NOT_ENROLL_VIEW = "PART_NOT_ENROLL_VIEW",
  PARTICIPANT_VIEW_IMAGE_RESULTS = "PARTICIPANT_VIEW_IMAGE_RESULTS",
  ENROLL_ADD = "ENROLL_ADD",
  ENROLL_CROSS_REDEEM = "ENROLL_CROSS_REDEEM",
  ENROLL_SINGLE_REDEEM = "ENROLL_SINGLE_REDEEM",
  DASH_VIEW = "DASH_VIEW",
  REPORT_VIEW = "REPORT_VIEW",
  PART_INCT_PROG_REP = "PART_INCT_PROG_REP",
  HELP_VIEW = "HELP_VIEW",
  GEO_VIEW = "GEO_VIEW",
  PART_TIMELINE_VIEW = "PART_TIMELINE_VIEW", // COYN-1507: participant timeline
}

export enum ActionTypeEnum {
  MENU_OPTION = "MENU_OPTION",
  OPTION = "OPTION",
}
